import { createRoute } from '@tanstack/react-router'
import { managementLayoutRoute } from '@/ui/pages/management'
import { LeadsByInvestigationSection } from './components/LeadsByInvestigationSection'
import { QuickActionsSection } from './components/QuickActionsSection'
import { RecentInvestigationsSection } from './components/RecentInvestigationsSection'
import { StatsSection } from './components/StatsSection'

export const dashboardRoute = createRoute({
  getParentRoute: () => managementLayoutRoute,
  path: 'dashboard',
  component: DashboardPage,
})

export function DashboardPage() {
  return (
    <div className="space-y-8">
      <StatsSection />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-1">
          <RecentInvestigationsSection />
        </div>
        <div className="lg:col-span-2">
          <LeadsByInvestigationSection />
        </div>
      </div>

      <QuickActionsSection />
    </div>
  )
}
